/* eslint-disable max-len */
import React from 'react';
import { SVGComp, PathComp } from '../../components/Svgs';
import { useTheme } from '@hmsexp/component-library';

const DownloadIcon = ({ width = '14', height = '14', viewBox = '0 0 14 14', stroke, strokeWidth = 1.5 }) => {
  const theme = useTheme();
  const strokeFill = stroke ? stroke : theme.palette.common.white;
  return (
    <SVGComp width={width} height={height} viewBox={viewBox} fill="none">
      <PathComp
        d="M13 9V11.6667C13 12.0203 12.8595 12.3594 12.6095 12.6095C12.3594 12.8595 12.0203 13 11.6667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V9M3.66667 5.66667L7 9M7 9L10.3333 5.66667M7 9V1"
        stroke={strokeFill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
    </SVGComp>
  );
};

export default DownloadIcon;
